import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { bentoniteMinerals, countryProduct} from "../Data";
import BreadCrumb from "../Components/BreadCrumb";
import NotFound from "./NotFound";
import CountryCta from "../Components/CountryCta";
import MineralTabs from "../Components/MineralTabs";
import ProductProcess from "../Components/ProductProcess";
import Certificates from "../Components/Certificates";
import OtherMinerals from "../Components/OtherMinerals";
import MineralFaqs from "../Components/MineralFaqs";
import MineralCta from "../Components/MineralCta";
import CountryStatCards from "../Components/CountryStatCards";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import productSchema from "../Schema/ProductSchema";

const CountryProducts=()=>{
      const { country, slug } = useParams();
      const product = countryProduct.find(
  item =>
    item.url === slug &&
    item.country.toLowerCase() === country.toLowerCase()
);

useEffect(() => {
        if (!product) return;
        document.title = product.metaTitle;
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) metaDesc.setAttribute("content", product.metaDescription);

        const metaKeywords = document.querySelector("meta[name='keywords']");
if (metaKeywords) {
  metaKeywords.setAttribute("content", product.metaKeywords);
}
    
          let canonical = document.querySelector("link[rel='canonical']");
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
    
      canonical.setAttribute(
        "href",
        `https://irisimpulse.com/${slug}`
      );
    
       const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
        product.metaTitle
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
       product.metaDescription
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content",  `https://irisimpulse.com/${slug}`);
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          `https://irisimpulse.com${product.ogImage}`
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
         product.metaTitle
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
        product.metaDescription
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          `https://irisimpulse.com${product.ogImage}`
        );
      }
    
    }, [product, slug]);
    

  if (!product) return <NotFound />;

  const pageUrl = `https://irisimpulse.com/${slug}`;

const productImage = product.ogImage.startsWith("http")
  ? product.ogImage
  : `https://irisimpulse.com/${product.ogImage.replace(/^\/+/, "")}`;

const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: product.title,
    },
  ],
});

const productData = productSchema({
  name: product.title,
  description: product.metaDescription,
  image: productImage,
  url: pageUrl,
});

    return(
        <>
         <SchemaMarkup data={breadcrumbData} />
    <SchemaMarkup data={productData} />

          <React.Fragment key={slug}>
         <BreadCrumb
        title={product.title}
        bgImage={product.bgImg}
      />

      <div style={{marginTop:"-80px"}}></div>


         {product.stats && product.stats.length > 0 && (
  <CountryStatCards
    heading1={product.introHeading}
    para1={product.introDesc}
    heading2={product.statsHeading}
    para2={product.statsDesc}
    stats={product.stats}
  />
)}


         {/**TABS SECTION */}
      <MineralTabs
  data={product.tabsData}
/>

        {/**ENQUIRE NOW SECTION */}
        <CountryCta
  heading={product.ctaHeading}
  desc={product.ctaDesc}
  popupHeading={`Do enquiry for ${product.formHeading}`}
  enquiryTitle={product.formHeading}
/>


      {/**EXPORT PROCESS SECTION */}
      <ProductProcess
        subheading={product.processSubHeading}
        heading={product.processHeading}
        desc={product.processDesc}
      />

      {/**CERTIFICATES SECTION */}
      <Certificates
  heading={product.certiHeading}
/>

      {/**OTHER MINERALS SECTION */}
      <OtherMinerals
  heading={product.otherMineralHeading}
  minerals={bentoniteMinerals}
  selectedMinerals={product.relatedMinerals}
  basePath="/bentonite-minerals"
/>

       {/**FAQS SECTION */}
        <MineralFaqs
          heading={product.faqHeading}
          faqs={product.faqs}
        />

      {/**CTA SECTION */}
      <div
  className="bottom-line"
>
        <MineralCta
        heading={product.cta2Heading}
        desc={product.cta2Desc}
        />
        </div>
      </React.Fragment>
        </>
    )
}
export default CountryProducts;